export default "__VITE_ASSET__DUSupMmF__"